import { handleActions } from 'redux-actions';
import { defaultAiContentWidgetState } from './defaults';
import { AiContentWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  INITIAL_SAVE_REQUEST_META,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  saveAiContent,
  saveAiContentFailure,
  saveAiContentSuccess,
  setAiContentWidgetShowAi,
} from './actions';

const mergeAiContentWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultAiContentWidgetState);

export default handleActions<AiContentWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => {
      const data: AiContentWidgetData['initialData'] = {
        showAi: action.payload.data.showAi,
      };

      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setAiContentWidgetShowAi.toString()]: (
      state,
      action: ReturnType<typeof setAiContentWidgetShowAi>
    ) =>
      mergeAiContentWidgetDataChange(state, {
        showAi: action.payload.showAi,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveAiContent,
      successAction: saveAiContentSuccess,
      failureAction: saveAiContentFailure,
    }),
  },
  defaultAiContentWidgetState
);
